// import React from 'react';

// import TeachHeader from './TeachHeader'
// import  { useState } from 'react';

// const Container = () => {
//   return (
//     <div className="containerw">
//       <div className="row">
//         <div className="col-md-4  mt-4">
//           <div className="container-content">
//             <p className="paragraph">Course:</p>
//             <p className="paragraph">Course Date:</p>
//             <p className="paragraph">Trainers:</p>
//           </div>
//         </div>

//         <div className="col-md-4  mt-4">
//           <div className="container-content">
//             <p className="paragraph">Batch:</p>
//             <p className="paragraph">Student Enrolled:</p>
//             <p className="paragraph">Assessors:</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };


// const Table = () => {
// const [data, setData] = useState([
//   {
//     name: 'John Doe',
//     id: 1,
//     email: 'john@example.com',
//     phone: '123-456-7890',
//     gender: 'Male',
//     dob: '1990-01-01',
//     address: '123 Main St, City, Country',
//   },
//   {
//     name: 'Jane Smith',
//     id: 2,
//     email: 'jane@example.com',
//     phone: '987-654-3210',
//     gender: 'Female',
//     dob: '1995-05-15',
//     address: '456 Park Ave, Town, Country',
//   },
//   // Add more dummy data here as needed
// ]);
// const styles = {
//   tableContainer: {
//     // Add your container styles here
//   },
//   searchContainer: {
//     // Add your search container styles here
//   },
//   tableHeader: {
//     // Add your table header styles here
//   },
//   tableCell: {
//     // Add your table cell styles here
//     border: '1px solid black',
//     padding: '8px',
//   },
// };


//   return (
//     <div>
//       <TeachHeader/>
//       <Container />

//       <div style={{ width: '100%', overflowX: 'auto' }}>
//     <table style={{ width: '54%', tableLayout: 'fixed' , marginLeft: '18%' }}>
//           {/* Add search input or any other elements here */}
      
      
//           <thead>
//             <tr style={styles.tableHeader}>
//               <th style={styles.tableCell}>Name</th>
//               <th style={styles.tableCell}>Id</th>
//               <th style={styles.tableCell}>Email</th>
//               <th style={styles.tableCell}>Phone</th>
//               <th style={styles.tableCell}>Gender</th>
//               <th style={styles.tableCell}>DOB</th>
//               <th style={styles.tableCell}>Address</th>
//             </tr>
//           </thead>
//           <tbody>
//             {data.map((row, index) => (
//               <tr key={index}>
//                 <td style={styles.tableCell}>{row.name}</td>
//                 <td style={styles.tableCell}>{row.id}</td>
//                 <td style={styles.tableCell}>{row.email}</td>
//                 <td style={styles.tableCell}>{row.phone}</td>
//                 <td style={styles.tableCell}>{row.gender}</td>
//                 <td style={styles.tableCell}>{row.dob}</td>
//                 <td style={styles.tableCell}>{row.address}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         <div
//           className=""
//           style={{ display: 'flex', justifyContent: 'flex-end' , translate: '-26%' , marginTop: '-2%' }}
//         >
//           <button
//             className=""
//             style={{
//               backgroundColor: '#03396c',
//               color: '#fff',
//               marginRight: '2%',
//               border: 'none',
//               padding: '8px 40px',
//               borderRadius: '4px',
//               cursor: 'pointer',
//               fontSize: '14px',
//               marginTop: '3%',
//             }}
//           >
//             Previous
//           </button>

//           <button
//             className=""
//             style={{
//               backgroundColor: '#03396c',
//               color: '#fff',
//               border: 'none',
//               marginRight: '2%',
//               padding: '8px 50px',
//               borderRadius: '4px',
//               cursor: 'pointer',
//               fontSize: '14px',
//               marginLeft: '10px',
//               marginTop: '3%',
//             }}
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Table;




import React, { useEffect, useState, useCallback } from 'react';
import axios from '../Axiosinstance';

/* ════════════════════════════════════════════════════════════════
   StudentFeedbackPage — FULL SCREEN fixed overlay
   Font: Montserrat · Colors: #1565C0 / #1976D2 / white / #F5F6FA
════════════════════════════════════════════════════════════════ */

const BLUE       = '#1565C0';
const BLUE_LIGHT = '#E3F2FD';
const BLUE_MID   = '#1976D2';
const BLUE_DARK  = '#0D47A1';
const ACCENT     = '#008eed';
const GREEN      = '#2E7D32';
const GREEN_BG   = '#E8F5E9';
const AMBER      = '#F57F17';
const AMBER_BG   = '#FFFDE7';
const RED        = '#C62828';
const RED_BG     = '#FFEBEE';
const GREY_BG    = '#F5F6FA';
const GREY_CARD  = '#FFFFFF';
const GREY_BORDER= '#E0E0E0';
const GREY_TEXT  = '#757575';
const DARK_TEXT  = '#212121';
const MID_TEXT   = '#424242';
const FONT       = "'Montserrat', 'Segoe UI', Arial, sans-serif";

/* ── Spinner ─────────────────────────────────────────────────── */
const Spinner = ({ size = 22, color = BLUE_MID }) => (
  <div style={{
    width: size, height: size, borderRadius: '50%',
    border: `2.5px solid ${color}28`,
    borderTopColor: color,
    animation: 'sfp_spin .65s linear infinite',
    flexShrink: 0,
  }} />
);

/* ── Type chip ───────────────────────────────────────────────── */
const TypeChip = ({ type }) => {
  const map = {
    MODULE: { bg: BLUE_LIGHT,  color: BLUE,      label: 'Module'  },
    COURSE: { bg: '#E0F7FA',   color: '#00838F', label: 'Course'  },
    ALUMNI: { bg: AMBER_BG,    color: AMBER,     label: 'Alumni'  },
  };
  const c = map[type] || { bg: GREY_BG, color: GREY_TEXT, label: type || '—' };
  return (
    <span style={{
      display: 'inline-block',
      padding: '3px 10px', borderRadius: 20,
      background: c.bg, color: c.color,
      fontSize: 11, fontWeight: 700,
      letterSpacing: '0.4px', fontFamily: FONT,
    }}>
      {c.label}
    </span>
  );
};

/* ── Linear progress ─────────────────────────────────────────── */
const LinearProgress = ({ value }) => (
  <div style={{ height: 4, borderRadius: 2, background: BLUE_LIGHT, overflow: 'hidden' }}>
    <div style={{
      height: '100%', width: `${value}%`,
      background: `linear-gradient(90deg, ${ACCENT} 0%, ${BLUE_MID} 100%)`,
      borderRadius: 2, transition: 'width .4s ease',
    }} />
  </div>
);

/* ══════════════════════════════════════════════════════════════
   FORM CARD
══════════════════════════════════════════════════════════════ */
const FormCard = ({ form, index, onSelect }) => {
  const [hovered, setHovered] = useState(false);
  const isCompleted = form.completed;
  const stripColor = isCompleted ? GREEN
    : form.feedbackType === 'MODULE' ? BLUE_DARK
    : form.feedbackType === 'ALUMNI' ? AMBER
    : BLUE_MID;

  return (
    <div
      onClick={() => !isCompleted && onSelect(form)}
      onMouseEnter={() => !isCompleted && setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: GREY_CARD,
        border: `1px solid ${hovered ? BLUE_MID : GREY_BORDER}`,
        borderLeft: `4px solid ${stripColor}`,
        borderRadius: 10,
        padding: '16px 18px',
        cursor: isCompleted ? 'default' : 'pointer',
        display: 'flex', alignItems: 'center', gap: 14,
        boxShadow: hovered ? '0 4px 16px rgba(25,118,210,0.13)' : '0 1px 4px rgba(0,0,0,0.05)',
        transition: 'border-color .18s, box-shadow .18s',
        opacity: isCompleted ? 0.82 : 1,
        animation: `sfp_fadeUp .3s ease ${index * 0.06}s both`,
      }}
    >
      <div style={{
        width: 42, height: 42, borderRadius: '50%',
        background: isCompleted ? GREEN_BG : BLUE_LIGHT,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0, fontSize: 19,
      }}>
        {isCompleted ? '✓' : '📋'}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', gap: 6, marginBottom: 6, flexWrap: 'wrap', alignItems: 'center' }}>
          <TypeChip type={form.feedbackType} />
          {form.moduleNumber && (
            <span style={{ padding: '2px 8px', borderRadius: 20, background: BLUE_LIGHT, color: BLUE, fontSize: 11, fontWeight: 700, fontFamily: FONT }}>
              Module {form.moduleNumber}
            </span>
          )}
          {isCompleted && (
            <span style={{ padding: '2px 8px', borderRadius: 20, background: GREEN_BG, color: GREEN, fontSize: 11, fontWeight: 700, fontFamily: FONT }}>
              ✓ Submitted
            </span>
          )}
        </div>
        <p style={{ fontSize: 15, fontWeight: 600, color: DARK_TEXT, fontFamily: FONT, marginBottom: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', margin: 0 }}>
          {form.title}
        </p>
        <p style={{ fontSize: 12, color: GREY_TEXT, fontFamily: FONT, margin: 0, marginTop: 3 }}>
          {form.questions?.length || 0} question{form.questions?.length !== 1 ? 's' : ''}
          {form.moduleName ? ` · ${form.moduleName}` : ''}
        </p>
      </div>

      {!isCompleted && (
        <div style={{
          width: 32, height: 32, borderRadius: '50%',
          background: hovered ? BLUE_MID : BLUE_LIGHT,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0, color: hovered ? '#fff' : BLUE_MID,
          fontSize: 18, fontWeight: 700, transition: 'all .18s',
        }}>›</div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════════════════════════════
   FORM VIEW — question by question
══════════════════════════════════════════════════════════════ */
const FeedbackFormView = ({ form, studentId, onBack, onSuccess }) => {
  const [answers, setAnswers]       = useState({});
  const [step, setStep]             = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError]           = useState('');

  const questions = form.questions || [];
  const current   = questions[step];
  const total     = questions.length;
  const isFinal   = step === total - 1;
  const progress  = total > 0 ? Math.round((step / total) * 100) : 0;

  const setAnswer = (qId, val) => setAnswers(prev => ({ ...prev, [qId]: val }));

  const canProceed = useCallback(() => {
    if (!current) return false;
    if (!current.required) return true;
    const val = answers[current.id];
    return val != null && String(val).trim().length > 0;
  }, [current, answers]);

  const parseMcqOptions = (raw) => {
    try {
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;
      return JSON.parse(raw);
    } catch { return []; }
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    setError('');
    try {
      await axios.post('/api/feedback/submit', {
        studentId: Number(studentId),
        formId: form.id,
        answers: questions.map(q => ({
          questionId: q.id,
          answerText: q.questionType === 'TEXT' ? (answers[q.id] || '') : null,
          mcqSelectedOption: q.questionType === 'MCQ' ? (answers[q.id] || null) : null,
        })),
      });
      onSuccess();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data;
      setError(typeof msg === 'string' ? msg : 'Submission failed. Please try again.');
    } finally { setSubmitting(false); }
  };

  return (
    <div style={{ animation: 'sfp_slideIn .25s ease both', maxWidth: 780, margin: '0 auto', padding: '0 0 60px' }}>

      {/* Back */}
      <button onClick={onBack} style={{
        background: 'none', border: 'none', cursor: 'pointer',
        color: BLUE_MID, fontSize: 13, fontWeight: 600, fontFamily: FONT,
        display: 'inline-flex', alignItems: 'center', gap: 5,
        marginBottom: 24, padding: 0, transition: 'color .15s',
      }}
        onMouseEnter={e => e.currentTarget.style.color = BLUE_DARK}
        onMouseLeave={e => e.currentTarget.style.color = BLUE_MID}>
        ← Back to forms
      </button>

      {/* Header card */}
      <div style={{
        background: GREY_CARD, borderRadius: 12, border: `1px solid ${GREY_BORDER}`,
        borderTop: `3px solid ${BLUE_MID}`,
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: 20,
      }}>
        <div style={{ padding: '20px 24px 0' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
                <TypeChip type={form.feedbackType} />
                {form.moduleNumber && (
                  <span style={{ padding: '2px 8px', borderRadius: 20, background: BLUE_LIGHT, color: BLUE, fontSize: 11, fontWeight: 700, fontFamily: FONT }}>
                    Module {form.moduleNumber}
                  </span>
                )}
              </div>
              <h2 style={{ fontSize: 20, fontWeight: 700, color: DARK_TEXT, fontFamily: FONT, marginBottom: 4, margin: '0 0 4px' }}>
                {form.title}
              </h2>
              {form.moduleName && (
                <p style={{ fontSize: 12, color: GREY_TEXT, fontFamily: FONT, margin: 0 }}>{form.moduleName}</p>
              )}
            </div>
            <div style={{
              flexShrink: 0, textAlign: 'center',
              background: BLUE_LIGHT, borderRadius: 10, padding: '10px 16px', minWidth: 64,
            }}>
              <div style={{ fontSize: 26, fontWeight: 800, color: BLUE_MID, fontFamily: FONT, lineHeight: 1 }}>{step + 1}</div>
              <div style={{ fontSize: 10, color: GREY_TEXT, fontWeight: 600, marginTop: 2, fontFamily: FONT }}>of {total}</div>
            </div>
          </div>
        </div>
        <div style={{ padding: '12px 24px 18px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <span style={{ fontSize: 11, color: GREY_TEXT, fontWeight: 500, fontFamily: FONT }}>Question {step + 1} of {total}</span>
            <span style={{ fontSize: 11, color: BLUE_MID, fontWeight: 700, fontFamily: FONT }}>{progress}%</span>
          </div>
          <LinearProgress value={progress} />
        </div>
      </div>

      {/* Question card */}
      {current && (
        <div key={`q-${current.id}-${step}`} style={{
          background: GREY_CARD, borderRadius: 12, border: `1px solid ${GREY_BORDER}`,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: 16,
          animation: 'sfp_fadeUp .22s ease both', overflow: 'hidden',
        }}>
          {/* Question header */}
          <div style={{
            padding: '14px 24px', background: GREY_BG,
            borderBottom: `1px solid ${GREY_BORDER}`,
            display: 'flex', alignItems: 'center', gap: 10,
          }}>
            <div style={{
              width: 30, height: 30, borderRadius: 7,
              background: BLUE_MID, color: '#fff',
              fontSize: 13, fontWeight: 700, fontFamily: FONT,
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>{step + 1}</div>
            <span style={{ fontSize: 12, color: GREY_TEXT, fontWeight: 500, fontFamily: FONT }}>
              {current.questionType === 'MCQ' ? 'Multiple Choice' : 'Open Response'}
            </span>
            {current.required && (
              <span style={{
                marginLeft: 'auto', padding: '3px 10px', borderRadius: 20,
                background: RED_BG, color: RED, fontSize: 10, fontWeight: 700, fontFamily: FONT,
              }}>Required</span>
            )}
          </div>

          {/* Question body */}
          <div style={{ padding: '28px 24px 32px' }}>
            <p style={{ fontSize: 17, fontWeight: 600, color: DARK_TEXT, fontFamily: FONT, lineHeight: 1.55, marginBottom: 24, margin: '0 0 24px' }}>
              {current.questionText}
            </p>

            {/* MCQ */}
            {current.questionType === 'MCQ' && (
              <div style={{ display: 'grid', gap: 12 }}>
                {parseMcqOptions(current.mcqOptions).map((opt, i) => {
                  const sel = answers[current.id] === opt;
                  return (
                    <label key={i} onClick={() => setAnswer(current.id, opt)}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 14,
                        padding: '15px 18px', borderRadius: 10,
                        border: `2px solid ${sel ? BLUE_MID : GREY_BORDER}`,
                        background: sel ? BLUE_LIGHT : '#FAFAFA',
                        cursor: 'pointer', transition: 'border-color .16s, background .16s', fontFamily: FONT,
                      }}
                      onMouseEnter={e => { if (!sel) { e.currentTarget.style.borderColor = ACCENT; e.currentTarget.style.background = '#F0F9FF'; } }}
                      onMouseLeave={e => { if (!sel) { e.currentTarget.style.borderColor = GREY_BORDER; e.currentTarget.style.background = '#FAFAFA'; } }}
                    >
                      <div style={{
                        width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                        border: `2px solid ${sel ? BLUE_MID : '#BDBDBD'}`,
                        background: sel ? BLUE_MID : '#fff',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        transition: 'all .16s',
                      }}>
                        {sel && <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#fff' }} />}
                      </div>
                      <span style={{ fontSize: 14, fontFamily: FONT, fontWeight: sel ? 600 : 400, color: sel ? BLUE_DARK : MID_TEXT, transition: 'color .16s' }}>
                        {opt}
                      </span>
                    </label>
                  );
                })}
              </div>
            )}

            {/* Text */}
            {current.questionType === 'TEXT' && (
              <textarea
                value={answers[current.id] || ''}
                onChange={e => setAnswer(current.id, e.target.value)}
                placeholder="Type your answer here…"
                rows={5}
                style={{
                  width: '100%', padding: '14px 16px', boxSizing: 'border-box',
                  border: `1.5px solid ${GREY_BORDER}`, borderRadius: 10,
                  background: '#FAFAFA', fontFamily: FONT,
                  fontSize: 14, color: DARK_TEXT,
                  resize: 'vertical', lineHeight: 1.6,
                  outline: 'none', transition: 'border-color .18s, box-shadow .18s',
                }}
                onFocus={e => { e.target.style.borderColor = BLUE_MID; e.target.style.boxShadow = `0 0 0 3px ${BLUE_LIGHT}`; }}
                onBlur={e => { e.target.style.borderColor = GREY_BORDER; e.target.style.boxShadow = 'none'; }}
              />
            )}
          </div>
        </div>
      )}

      {/* Error */}
      {error && (
        <div style={{
          padding: '12px 16px', borderRadius: 10, marginBottom: 16,
          background: RED_BG, border: `1px solid ${RED}30`,
          color: RED, fontSize: 13, fontFamily: FONT,
          display: 'flex', alignItems: 'center', gap: 8,
        }}>
          <span>⚠</span> {error}
        </div>
      )}

      {/* Step dots */}
      {total > 1 && total <= 14 && (
        <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginBottom: 20, marginTop: 4 }}>
          {Array.from({ length: total }).map((_, i) => (
            <div key={i} style={{
              width: i === step ? 24 : 9, height: 9, borderRadius: 5,
              background: i === step ? BLUE_MID : i < step ? ACCENT : GREY_BORDER,
              transition: 'all .3s ease',
            }} />
          ))}
        </div>
      )}

      {/* Navigation */}
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
        <button onClick={() => setStep(s => Math.max(0, s - 1))} disabled={step === 0}
          style={{
            background: 'transparent', color: MID_TEXT,
            border: `1px solid ${GREY_BORDER}`, borderRadius: 10, padding: '12px 24px',
            fontSize: 14, fontWeight: 600, fontFamily: FONT,
            cursor: step === 0 ? 'not-allowed' : 'pointer', opacity: step === 0 ? 0.4 : 1,
            transition: 'background .15s',
          }}
          onMouseEnter={e => { if (step > 0) e.currentTarget.style.background = GREY_BG; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}>
          ← Previous
        </button>

        {!isFinal ? (
          <button onClick={() => canProceed() && setStep(s => s + 1)} disabled={!canProceed()}
            style={{
              background: canProceed() ? BLUE_MID : GREY_BORDER,
              color: canProceed() ? '#fff' : GREY_TEXT,
              border: 'none', borderRadius: 10, padding: '12px 28px',
              fontSize: 14, fontWeight: 600, fontFamily: FONT,
              cursor: canProceed() ? 'pointer' : 'not-allowed',
              transition: 'background .18s, box-shadow .18s',
              boxShadow: canProceed() ? '0 2px 8px rgba(25,118,210,0.25)' : 'none',
            }}
            onMouseEnter={e => { if (canProceed()) e.currentTarget.style.background = BLUE_DARK; }}
            onMouseLeave={e => { if (canProceed()) e.currentTarget.style.background = BLUE_MID; }}>
            Next →
          </button>
        ) : (
          <button onClick={handleSubmit} disabled={!canProceed() || submitting}
            style={{
              background: (canProceed() && !submitting) ? GREEN : GREY_BORDER,
              color: (canProceed() && !submitting) ? '#fff' : GREY_TEXT,
              border: 'none', borderRadius: 10, padding: '12px 28px',
              fontSize: 14, fontWeight: 600, fontFamily: FONT,
              cursor: (canProceed() && !submitting) ? 'pointer' : 'not-allowed',
              display: 'inline-flex', alignItems: 'center', gap: 8,
              minWidth: 170, justifyContent: 'center',
              transition: 'background .18s, box-shadow .18s',
              boxShadow: (canProceed() && !submitting) ? '0 2px 8px rgba(46,125,50,0.28)' : 'none',
            }}>
            {submitting ? <><Spinner size={16} color="#fff" /> Submitting…</> : <><span style={{ fontSize: 17 }}>✓</span> Submit Feedback</>}
          </button>
        )}
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════════
   SUCCESS SCREEN
══════════════════════════════════════════════════════════════ */
const SuccessScreen = ({ formTitle, onBack }) => (
  <div style={{ textAlign: 'center', padding: '80px 24px', animation: 'sfp_fadeUp .4s ease both', maxWidth: 480, margin: '0 auto' }}>
    <div style={{
      width: 80, height: 80, borderRadius: '50%',
      background: GREEN_BG, border: `3px solid ${GREEN}40`,
      margin: '0 auto 24px',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      animation: 'sfp_pop .4s cubic-bezier(.16,1,.3,1) .1s both',
    }}>
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none"
        stroke={GREEN} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </div>
    <h2 style={{ fontSize: 26, fontWeight: 700, color: DARK_TEXT, fontFamily: FONT, marginBottom: 12 }}>
      Feedback Submitted!
    </h2>
    <p style={{ color: GREY_TEXT, fontSize: 15, lineHeight: 1.65, maxWidth: 340, margin: '0 auto 32px', fontFamily: FONT }}>
      Your response for <strong style={{ color: DARK_TEXT }}>{formTitle}</strong> has been recorded. Thank you!
    </p>
    <button onClick={onBack} style={{
      background: BLUE_MID, color: '#fff', border: 'none',
      borderRadius: 10, padding: '13px 32px',
      fontSize: 15, fontWeight: 600, fontFamily: FONT, cursor: 'pointer',
      boxShadow: '0 2px 8px rgba(25,118,210,0.25)', transition: 'background .18s',
    }}
      onMouseEnter={e => e.currentTarget.style.background = BLUE_DARK}
      onMouseLeave={e => e.currentTarget.style.background = BLUE_MID}>
      Back to Forms
    </button>
  </div>
);

/* ══════════════════════════════════════════════════════════════
   EMPTY STATE
══════════════════════════════════════════════════════════════ */
const EmptyState = () => (
  <div style={{
    textAlign: 'center', padding: '64px 24px',
    background: GREY_CARD, borderRadius: 14,
    border: `1px dashed ${GREY_BORDER}`,
    animation: 'sfp_fadeUp .35s ease both',
    maxWidth: 480, margin: '0 auto',
  }}>
    <div style={{
      width: 64, height: 64, borderRadius: 14,
      background: BLUE_LIGHT, margin: '0 auto 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30,
    }}>📋</div>
    <h3 style={{ fontSize: 18, fontWeight: 700, color: DARK_TEXT, fontFamily: FONT, marginBottom: 10 }}>
      No Feedback Forms Available
    </h3>
    <p style={{ color: GREY_TEXT, fontSize: 13, lineHeight: 1.6, maxWidth: 280, margin: '0 auto', fontFamily: FONT }}>
      Your instructor hasn't published any feedback forms yet. Check back later.
    </p>
  </div>
);

/* ══════════════════════════════════════════════════════════════
   MAIN EXPORT — StudentFeedbackPage
   Props: batchId, intakeId, studentId, onClose
   Now renders as a FIXED FULL-SCREEN overlay
══════════════════════════════════════════════════════════════ */
const StudentFeedbackPage = ({ batchId, intakeId, studentId, onClose }) => {
  const [forms, setForms]               = useState([]);
  const [loading, setLoading]           = useState(true);
  const [selectedForm, setSelectedForm] = useState(null);
  const [submitted, setSubmitted]       = useState(false);

  const fetchEligibleForms = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (batchId)   params.append('batchId',   batchId);
      if (intakeId)  params.append('intakeId',  intakeId);
      if (studentId) params.append('studentId', studentId);
      const res = await axios.get(`/api/feedback/eligible?${params.toString()}`);
      setForms(Array.isArray(res.data) ? res.data : []);
    } catch { setForms([]); }
    finally { setLoading(false); }
  }, [batchId, intakeId, studentId]);

  useEffect(() => { fetchEligibleForms(); }, [fetchEligibleForms]);

  const handleBack = () => {
    setSelectedForm(null);
    setSubmitted(false);
    fetchEligibleForms();
  };

  const pending   = forms.filter(f => !f.completed);
  const completed = forms.filter(f =>  f.completed);

  return (
    /* ── Fixed full-screen overlay — covers the entire viewport ── */
    <div style={{
      position: 'fixed',
      top: 0, left: 0,
      width: '100vw', height: '100vh',
      zIndex: 1300,
      background: GREY_BG,
      fontFamily: FONT,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}>

      {/* Global keyframes */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap');
        @keyframes sfp_spin    { to { transform: rotate(360deg); } }
        @keyframes sfp_fadeUp  { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }
        @keyframes sfp_slideIn { from { opacity:0; transform:translateX(20px); } to { opacity:1; transform:translateX(0); } }
        @keyframes sfp_pop     { 0%{transform:scale(0);} 70%{transform:scale(1.15);} 100%{transform:scale(1);} }
      `}</style>

      {/* ── Top bar (sticky inside the overlay) ── */}
      <div style={{
        background: GREY_CARD,
        borderBottom: `1px solid ${GREY_BORDER}`,
        padding: '0 32px',
        height: 60,
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        flexShrink: 0,
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        zIndex: 10,
      }}>
        {/* Back / Close button */}
        {selectedForm ? (
          <button onClick={handleBack} title="Back" style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: GREY_TEXT, fontSize: 18, lineHeight: 1,
            padding: '5px 8px', borderRadius: 6,
            display: 'flex', alignItems: 'center', transition: 'background .15s, color .15s', fontFamily: FONT,
          }}
            onMouseEnter={e => { e.currentTarget.style.background = GREY_BG; e.currentTarget.style.color = DARK_TEXT; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = GREY_TEXT; }}>
            ←
          </button>
        ) : onClose ? (
          <button onClick={onClose} title="Close" style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: GREY_TEXT, fontSize: 18, lineHeight: 1,
            padding: '5px 8px', borderRadius: 6,
            display: 'flex', alignItems: 'center', transition: 'background .15s, color .15s', fontFamily: FONT,
          }}
            onMouseEnter={e => { e.currentTarget.style.background = GREY_BG; e.currentTarget.style.color = DARK_TEXT; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = GREY_TEXT; }}>
            ←
          </button>
        ) : null}

        {/* Icon */}
        <div style={{ width: 36, height: 36, borderRadius: 9, background: BLUE_MID, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
          </svg>
        </div>

        <div>
          <p style={{ fontSize: 16, fontWeight: 700, color: DARK_TEXT, fontFamily: FONT, lineHeight: 1.1, margin: 0 }}>
            {selectedForm ? selectedForm.title : 'Feedback'}
          </p>
          <p style={{ fontSize: 11, color: GREY_TEXT, marginTop: 2, fontFamily: FONT, margin: 0 }}>
            {selectedForm
              ? `Question 1 of ${selectedForm.questions?.length || 0}`
              : 'Share your course experience'}
          </p>
        </div>

        {/* Counters (list view only) */}
        {!selectedForm && !submitted && !loading && forms.length > 0 && (
          <div style={{ marginLeft: 'auto', display: 'flex', gap: 20, alignItems: 'center' }}>
            {pending.length > 0 && (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 20, fontWeight: 800, color: BLUE_MID, fontFamily: FONT, lineHeight: 1 }}>{pending.length}</div>
                <div style={{ fontSize: 9, color: GREY_TEXT, fontWeight: 600, letterSpacing: '0.5px', marginTop: 1, fontFamily: FONT }}>PENDING</div>
              </div>
            )}
            {pending.length > 0 && completed.length > 0 && (
              <div style={{ width: 1, height: 28, background: GREY_BORDER }} />
            )}
            {completed.length > 0 && (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 20, fontWeight: 800, color: GREEN, fontFamily: FONT, lineHeight: 1 }}>{completed.length}</div>
                <div style={{ fontSize: 9, color: GREY_TEXT, fontWeight: 600, letterSpacing: '0.5px', marginTop: 1, fontFamily: FONT }}>DONE</div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* ── Scrollable body ── */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '32px 24px 80px',
      }}>
        <div style={{ maxWidth: 860, margin: '0 auto' }}>

          {/* Loading */}
          {loading && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14, height: 260 }}>
              <Spinner />
              <span style={{ color: GREY_TEXT, fontSize: 14, fontFamily: FONT }}>Loading feedback forms…</span>
            </div>
          )}

          {/* Success */}
          {!loading && submitted && (
            <SuccessScreen formTitle={selectedForm?.title} onBack={handleBack} />
          )}

          {/* Form answering */}
          {!loading && !submitted && selectedForm && (
            <FeedbackFormView
              form={selectedForm}
              studentId={studentId}
              onBack={handleBack}
              onSuccess={() => setSubmitted(true)}
            />
          )}

          {/* List view */}
          {!loading && !submitted && !selectedForm && (
            <div style={{ animation: 'sfp_fadeUp .3s ease both' }}>
              <div style={{ marginBottom: 28 }}>
                <h1 style={{ fontSize: 24, fontWeight: 700, color: DARK_TEXT, fontFamily: FONT, marginBottom: 6, margin: '0 0 6px' }}>
                  Your Feedback Forms
                </h1>
                <p style={{ fontSize: 13, color: GREY_TEXT, fontFamily: FONT, margin: 0 }}>
                  {forms.length === 0
                    ? 'No forms available at the moment'
                    : `${pending.length} pending · ${completed.length} completed`}
                </p>
              </div>

              {/* Pending section */}
              {pending.length > 0 && (
                <div style={{ marginBottom: 32 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                    <span style={{ fontSize: 11, fontWeight: 700, color: GREY_TEXT, letterSpacing: '0.8px', textTransform: 'uppercase', fontFamily: FONT }}>Pending</span>
                    <div style={{ flex: 1, height: 1, background: GREY_BORDER }} />
                    <span style={{ padding: '2px 10px', borderRadius: 20, background: BLUE_LIGHT, color: BLUE_MID, fontSize: 11, fontWeight: 700, fontFamily: FONT }}>
                      {pending.length}
                    </span>
                  </div>
                  <div style={{ display: 'grid', gap: 12 }}>
                    {pending.map((form, i) => (
                      <FormCard key={form.id} form={form} index={i} onSelect={setSelectedForm} />
                    ))}
                  </div>
                </div>
              )}

              {/* Completed section */}
              {completed.length > 0 && (
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                    <span style={{ fontSize: 11, fontWeight: 700, color: GREY_TEXT, letterSpacing: '0.8px', textTransform: 'uppercase', fontFamily: FONT }}>Completed</span>
                    <div style={{ flex: 1, height: 1, background: GREY_BORDER }} />
                    <span style={{ padding: '2px 10px', borderRadius: 20, background: GREEN_BG, color: GREEN, fontSize: 11, fontWeight: 700, fontFamily: FONT }}>
                      {completed.length}
                    </span>
                  </div>
                  <div style={{ display: 'grid', gap: 12 }}>
                    {completed.map((form, i) => (
                      <FormCard key={form.id} form={form} index={i} onSelect={() => {}} />
                    ))}
                  </div>
                </div>
              )}

              {forms.length === 0 && <EmptyState />}
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default StudentFeedbackPage;

